import Button from '../Button/Button';
import React, { useState } from 'react';
import { FontAwesome } from '@expo/vector-icons';
import { GRAY_BACKGROUND } from '../../config/designSystem/Colors';
import { ParagraphMBold, ParagraphSRegular } from '../../config/designSystem/typography';
import {  TouchableOpacity  , View}
  from 'react-native';

interface ICollapsableProps2{
    title:string;
    content:string;
    button: string;
    onPress:() => void;
}
export const CollapsableWithRedoButton =({
  onPress,
  title,
  content,
  button
}: ICollapsableProps2)=>{

  const [collapsed, setCollapsed] =useState<boolean>(true);




  const onBtnPress =()=>{
    setCollapsed(coll=> !coll);
  };


  return( <TouchableOpacity style={{
    borderRadius: 15,
    backgroundColor: GRAY_BACKGROUND,
    padding:20,
    marginHorizontal:15,
    marginVertical:0,
  }}
  onPress={onBtnPress}>
    <View
      style={{
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        maxWidth: '95%',
      }}>
      <ParagraphMBold >{title} </ParagraphMBold>
      <FontAwesome name={collapsed ? 'chevron-down' : 'chevron-up'} />
    </View>
    {!collapsed && (
      <View style={{ marginTop: 10}}>
        <ParagraphSRegular >{content}</ParagraphSRegular>
        <View  style={{alignItems:'center'}}>
          <Button label={button} onPress={onPress} />
        </View>

      </View>)
    }
  </TouchableOpacity>
  );
};




